module.exports = __webpack_public_path__ + "media/icons/map-icon-polygon-dabfe6eb.svg";